export default function KipaCard({
  children,
  onPress,
  onClick,
  padding = 18,
  marginBottom = 12,
  className = "",
  testId,
}) {
  const Tag = onPress || onClick ? "button" : "div";
  return (
    <Tag
      type={Tag === "button" ? "button" : undefined}
      onClick={onPress || onClick}
      data-testid={testId}
      className={`kipa-card ${onPress || onClick ? "kipa-card-press kipa-btn-press flex items-center" : ""} ${className}`}
      style={{ padding, marginBottom }}
    >
      {children}
    </Tag>
  );
}
